function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Plan-Recommender",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Plan-Rec-6a",
  transform: "translate(-895.000000, -297.000000)",
  fill: "#57595b",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(526.000000, 282.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M377.5,15 C372.812912,15 369,18.812912 369,23.5 C369,28.187088 372.812912,32 377.5,32 C382.187088,32 386,28.187088 386,23.5 C386,18.812912 382.187088,15 377.5,15 Z M381.21875,24.2082901 L378.20829,24.2082901 L378.20829,27.21875 C378.20829,27.6097946 377.891045,27.9270401 377.5,27.9270401 C377.108955,27.9270401 376.79171,27.6097946 376.79171,27.21875 L376.79171,24.2082901 L373.78125,24.2082901 C373.390205,24.2082901 373.07296,23.8910446 373.07296,23.5 C373.07296,23.1089554 373.390205,22.7917099 373.78125,22.7917099 L376.79171,22.7917099 L376.79171,19.78125 C376.79171,19.3902054 377.108955,19.0729599 377.5,19.0729599 C377.891045,19.0729599 378.20829,19.3902054 378.20829,19.78125 L378.20829,22.7917099 L381.21875,22.7917099 C381.609795,22.7917099 381.92704,23.1089554 381.92704,23.5 C381.92704,23.8910446 381.609795,24.2082901 381.21875,24.2082901 L381.21875,24.2082901 Z",
  id: "icon-add"
}))));
function SvgIconAdd(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, ["title", "titleId"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "17px",
    height: "17px",
    viewBox: "0 0 17 17",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "F95D62D6-941E-493B-B142-D394A8D6B237") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAdd);
export default __webpack_public_path__ + "static/media/icon-add.ee45b13b.svg";
export { ForwardRef as ReactComponent };